import { logBookingEngineConversion } from './ab-test-logger'

window.dataLayer = window.dataLayer || []
const dataLayer = window.dataLayer

const rootDs = document.querySelector('[data-dl]')

const push = function (data) {
  dataLayer.push(data)
}

const handleClickEvent = async (event, eventName, additionalData = {}) => {
  const clickUrl = event.currentTarget.getAttribute('href')
  const closestParentWithDataAt = event.currentTarget.closest('[data-at]')
  const clickText = event.currentTarget.textContent.trim()
  const pageUrl = window.location.href
  const pageTitle = rootDs.dataset.pageTitle
  const pageSection = closestParentWithDataAt != null ? closestParentWithDataAt.dataset.at : null
  const abTest = rootDs.dataset.abTest ? JSON.parse(rootDs.dataset.abTest) : null

  push({
    event: 'gaEvent',
    event_name: eventName,
    click_url: clickUrl,
    click_text: clickText,
    page_url: pageUrl,
    page_title: pageTitle,
    page_section: pageSection,
    ab_test: abTest,
    ...additionalData
  })

  if (clickUrl &&
    (clickUrl.indexOf('/booking?') !== -1 ||
    clickUrl.indexOf('/booking/') !== -1)) {
    await logBookingEngineConversion()
  }
}

const sitewideTracking = function () {
  if (rootDs) {
    push({
      event: 'pageview',
      page_title: rootDs.dataset.pageTitle,
      page_type: rootDs.dataset.pageType,
      page_url: window.location.href,
      mobile_app: false,
      step: null,
      step_name: null,
      user_details: {
        logged_in_status: rootDs.dataset.status === 'True',
        user_id: rootDs.dataset.uid,
        email: rootDs.dataset.email,
        country: rootDs.dataset.country,
        language: rootDs.dataset.language
      },
      ab_test: rootDs.dataset.abTest ? JSON.parse(rootDs.dataset.abTest) : null
    })
  }
}

const bookingTracking = async () => {
  const bookingUrl = document.querySelector('[data-booking-url]')
  const bookingBar = document.querySelector('[data-bar-search-button]')
  const bookingLinks = Array.from(document.querySelectorAll(`a[href*="${bookingUrl.dataset.bookingUrl}"]`))

  const attachEventToLink = (link) => {
    link.addEventListener('click', async (event) => {
      await handleClickEvent(event, 'book_now_click')
    })
  }

  bookingLinks.forEach(link => {
    attachEventToLink(link)
  })

  if (bookingBar) {
    attachEventToLink(bookingBar)
  }

  const observeNewElements = () => {
    const bookingBarContainer = document.querySelector('[data-booking-bar-container]')
    if (!bookingBarContainer) return

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const newBookingBar = node.querySelector('[data-bar-search-button]')
            if (newBookingBar) {
              attachEventToLink(newBookingBar)
            }
          }
        })
      })
    })

    mutationObserver.observe(bookingBarContainer, {
      childList: true,
      subtree: true
    })
  }

  observeNewElements()
}

const navigationTracking = () => {
  const addNavigationHandler = (link, eventName) => {
    link.addEventListener('click', async (event) => {
      const hierarchyLevel = link.getAttribute('data-menu-hierarchy')
      let headerHierarchy1 = ''
      let headerHierarchy2 = ''
      let headerHierarchy3 = ''

      if (hierarchyLevel === '3') {
        headerHierarchy3 = link.textContent
        const mmList = link.closest('.mm__item')
        if (mmList) {
          const lvl2Link = mmList.querySelector('[data-menu-hierarchy="2"]')
          if (lvl2Link) {
            headerHierarchy2 = lvl2Link.textContent
          }
          const lvl1Link = mmList.querySelector('[data-menu-hierarchy="1"]')
          if (lvl1Link) {
            headerHierarchy1 = lvl1Link.textContent
          }
        }
      } else if (hierarchyLevel === '2') {
        headerHierarchy2 = link.textContent
        const mmList = link.closest('.mm__item')
        if (mmList) {
          const lvl1Link = mmList.querySelector('[data-menu-hierarchy="1"]')
          if (lvl1Link) {
            headerHierarchy1 = lvl1Link.textContent
          }
        }
      } else if (hierarchyLevel === '1') {
        headerHierarchy1 = link.textContent
      }

      await handleClickEvent(event, eventName, {
        header_hierarchy_1: headerHierarchy1.trim(),
        header_hierarchy_2: headerHierarchy2.trim(),
        header_hierarchy_3: headerHierarchy3.trim()
      })
    })
  }

  const navLinks = document.querySelectorAll('[data-menu-hierarchy]')
  navLinks.forEach(link => {
    addNavigationHandler(link, 'navigation_click')
  })
}

const footerTracking = () => {
  const footerLinks = document.querySelectorAll('[data-footer-link]')
  footerLinks.forEach(link => {
    link.addEventListener('click', async (event) => {
      await handleClickEvent(event, 'footer_click')
    })
  })
}

const socialTracking = () => {
  const socialLinks = document.querySelectorAll('[data-social-link]')
  socialLinks.forEach(link => {
    link.addEventListener('click', async (event) => {
      await handleClickEvent(event, 'social_click')
    })
  })
}

const shareTracking = () => {
  const sharelLinks = document.querySelectorAll('[data-share-link]')
  sharelLinks.forEach(link => {
    link.addEventListener('click', async (event) => {
      await handleClickEvent(event, 'share_click', { share_channel: event.target.dataset.shareLink })
    })
  })
}

const callToActionTracking = () => {
  const ctaLinks = document.querySelectorAll('[data-cta-link]')
  ctaLinks.forEach(link => {
    link.addEventListener('click', async (event) => {
      await handleClickEvent(event, 'call_to_action')
    })
  })
}

export {
  sitewideTracking,
  bookingTracking,
  navigationTracking,
  footerTracking,
  socialTracking,
  shareTracking,
  callToActionTracking
}
